/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/data-view-filter.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2024 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const getPropArray = (newItem) => {
    let propArray = [];

    // Display Index will always be -1 for non site and subject filters. And if it is not site and subject filters then we
    // are not showing displayIndex

    if (newItem?.displayIndex !== -1) {
        propArray = ['CfId', 'IsDefault', 'FieldKey', 'DisplayIndex', 'FieldName'];
    } else {
        propArray = ['CfId', 'IsDefault', 'DisplayIndex', 'DisplayOrder', 'FieldKey', 'FieldName'];
    }
    return propArray;
};

const DataViewFilterChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const propArray = getPropArray(newItem);

    const refactorRecord = (record) => {
        return {
            ...record,
            ConfigId: record.CfId?.$oid,
            Field: record.FieldName,
            DisplayOrder: record.DisplayIndex,
            ...removePropertiesFromObject(record, propArray),
        } as Record<string, unknown>;
    };

    const refactoredOldRecord = refactorRecord(oldRecord);
    const refactoredNewRecord = refactorRecord(newRecord);

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            refactoredOldRecord,
            refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { DataViewFilterChangeGrid };
